



















import Vue from 'vue'

interface ScaleToOptions {
  allowChangeEvent: boolean
  originX?: string | number
  originY?: string | number
  relativeTo?: string
}

interface Styles {
  [property: string]: string
}

export default Vue.extend({
  props: {
    alt: {
      type: String,
      default: "image"
    },
    imageSrc: {
      type: String,
      default: ""
    },
    index: {
      type: [String, Number],
      default: 0
    },
    maxScale: {
      type: Number,
      default: 50
    },
  },
  data() {
    return {
      clicked: false,
      drag: {
        active: false,
        end: {
          x: 0,
          y: 0
        },
        start: {
          x: 0,
          y: 0
        }
      },
      doubleClick: 0,
      frame: {
        height: 1,
        width: 1
      },
      image: {
        height: 1,
        width: 1
      },
      minScale: 1,
      scaleAlert: 0,
      zoom: {
        scale: 1,
        x: 0,
        y: 0
      }
    }
  },
  computed: {
    imageStyle: {
      get():Styles {
        const width = this.image.width * this.zoom.scale + 'px'
        const cursor = 'move'
        const styles:Styles = {
          cursor,
          width,
          maxWidth: this.image.width * this.maxScale + 'px',
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: this.transform(-this.zoom.x, -this.zoom.y)
        }
        return styles
      },
      set(style) {
        return
      }
    },
    limits() {
      const a = this.frame.width
      const b = this.frame.height
      const i = this.image.width
      const j = this.image.height
      const c = a/b
      const k = i/j

      let limits = { min: 0, max: 0 }
      let x = {...limits}
      let y = {...limits}

      if ( c > k ) {
        y = {
          min: this.frame.height / 2,
          max: this.image.height * this.zoom.scale - this.frame.height / 2
        }

        if ( this.zoom.scale > this.frame.width / this.image.width) {
          x = {
            min: this.frame.width / 2,
            max: this.image.width * this.zoom.scale - this.frame.width / 2
          }
        } else {
          x = {
            min: this.image.width * this.zoom.scale / 2,
            max: this.image.width * this.zoom.scale / 2
          }
        }
      } else {
        x = {
          min: this.frame.width / 2,
          max: this.image.width * this.zoom.scale - this.frame.width / 2
        }

        if ( this.zoom.scale > this.frame.height / this.image.height) {
          y = {
            min: this.frame.height / 2,
            max: this.image.height * this.zoom.scale - this.frame.height / 2
          }
        } else {
          y = {
            min: this.image.height * this.zoom.scale / 2,
            max: this.image.height * this.zoom.scale / 2
          }
        }
      }
      return { x, y }
    }
  },
  methods: {
    imageClick(event, index) {
      if (!this.clicked) {
        this.$emit('selectFrame', index)
        this.clicked = true
        this.doubleClick = setTimeout(() => {
          this.clicked = false
        }, 200)
      } else {
        this.scaleTo(this.zoom.scale * 1.38, {
          originX: event.offsetX,
          originY: event.offsetY,
          relativeTo: 'content',
          allowChangeEvent: true
        })
        this.clicked = false
        clearTimeout(this.doubleClick)
      }
    },

    imageDrag(event?) {

      if (event) {
        event.preventDefault()
        
        const drag = (e) => {
          this.setTransform({
            scale: this.zoom.scale, 
            x: this.drag.start.x + event.clientX - e.clientX,
            y: this.drag.start.y + event.clientY - e.clientY
          }, true)
        }

        if(!this.drag.active) {
          this.drag.active = true
          this.drag.start.x = this.zoom.x
          this.drag.start.y = this.zoom.y
          document.onmousemove = drag
        } else {
          document.onmousemove = null
          this.drag.active = false
        }
      } else {
        this.drag.active = false
        document.onmousemove = null
      }
    },

    touchDrag(e, touch) {
      const transform = {
        scale: this.zoom.scale, 
        x: this.drag.start.x + touch.clientX - e.touches[0].clientX,
        y: this.drag.start.y + touch.clientY - e.touches[0].clientY
      }
      this.setTransform(transform, true)
    },

    touchStart(event, index) {
      event.preventDefault()
      const touch = event.touches[0]
      this.imageClick(touch, index)

      this.drag.start.x = this.zoom.x
      this.drag.start.y = this.zoom.y

      document.ontouchmove = (e) => this.touchDrag(e, touch)
    },

    touchEnd(event) {
      event.preventDefault();
      document.ontouchmove = null
    },
    
    init() {
      const frame:any = document.getElementById('imageFrame' + this.index)
      const image:any = document.getElementById('image' + this.index)
      const waitForImage = setInterval(() => {
        if (image && image.complete) {

          this.frame.height = frame.clientHeight
          this.frame.width = frame.clientWidth

          const x = image.naturalWidth
          const y = image.naturalHeight

          const a = this.frame.width / this.frame.height
          const b = x/y

          let imageHeight = 0
          let imageWidth = 0

          if (a > b) {
            imageHeight = this.frame.height
            imageWidth = imageHeight * b
          } else {
            imageWidth = this.frame.width
            imageHeight = imageWidth / b
          }

          this.image.height = imageHeight
          this.image.width = imageWidth


          const zoom = {scale: 1, x: this.image.width / 2, y: this.image.height / 2}
          this.zoom = zoom
          this.setTransform(zoom, true)
          clearInterval(waitForImage)
        }
      }, 50)
    },
    scaleTo(scale:number, options: ScaleToOptions) {
      const scaleFactor = scale/this.zoom.scale
      let x = options.originX
      let y = options.originY
      let newX:number = this.zoom.x
      let newY:number = this.zoom.y

      if (typeof x != "undefined") {
        if (typeof x === "string" && x.slice(x.length - 1) === "%") {
          if (options.relativeTo === "content") {
            newX = Number(x.split('%')[0])/100 * this.image.width * scale
          } else {
            newX = this.zoom.x * scaleFactor
          }
        }
        if (typeof x === "number") {
          newX = x * scaleFactor
        }
      }

      if (typeof y != "undefined") {
        if (typeof y === "string" && y.slice(y.length - 1) === "%") {
          if (options.relativeTo === "content") {
            newY = Number(y.split('%')[0])/100 * this.image.height * scale
          } else {
            newY = this.zoom.y * scaleFactor
          }
        }
        if (typeof y === "number") {
          newY = y * scaleFactor

        }
      }

      this.setTransform({scale, x: newX, y: newY}, true)
    },
    scrollZoom(event) {
      event.preventDefault()
      const scale = this.zoom.scale - event.deltaY * 0.01
      const scaleFactor = scale/this.zoom.scale

      this.scaleTo(scale, {
        originX: "50%",
        originY: "50%",
        relativeTo: "container",
        allowChangeEvent: true
      })
      
    },
    setTransform(zoom:{scale: number, x:number, y:number}, allowChangeEvent = false) {

      let {scale, x, y} = zoom
      
      if (scale < this.minScale || scale > this.maxScale) {
        
        if (!this.scaleAlert) {
          this.scaleAlert = 1
          setTimeout(() => {
            this.scaleAlert = 0
          }, 1000)
        }

      } else {

        this.$set(this.zoom, 'scale', scale)

        if (x < this.limits.x.min) {
          x = this.limits.x.min
        } else if (x > this.limits.x.max) {
          x = this.limits.x.max
        }

        if (y < this.limits.y.min) {
          y = this.limits.y.min
        } else if (y > this.limits.y.max) {
          y = this.limits.y.max
        }

        const _zoom = {...this.zoom}
        const newZoom = {scale, x, y}
        
        if (_zoom != {scale, x, y}) {
          this.zoom = {scale, x, y}
          allowChangeEvent ? this.$emit('change', this.zoom) : null
        }

      }
      
    },
    transform(x: number, y?:number) {
      let translate = ""
      if (x && y) {
        translate = `translate(${x + 'px'}, ${y + 'px'})`
      }
      if (!x) {
        translate = `translateY(${y + 'px'})`
      }
      if (!y) {
        translate = `translateX(${x + 'px'})`
      }
      return translate
      
    }
  },
  mounted() {
    this.init()
    window.addEventListener('resize', () => this.init())
  }
})
